<template>

  <el-form ref='licenseeForm' v-model="telco" label-position="top">
    <el-row :gutter="24">

      <el-col :span="12">
        <el-form-item label="Sharer">
          <strong>{{sharerName}}</strong>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Telco Site ID" required>
          <el-input placeholder="Site ID" v-model="telco.telcoSiteId" :disabled="stepSaved || canEdit" />
        </el-form-item>
      </el-col>
    </el-row>

    <section  v-if="!canEdit">
      <el-row :gutter="12">
        <el-col :md="24" :lg="12">
          <select-service-type v-model="telco.serviceType"  :disabled="stepSaved || canEdit" />
        </el-col>

        <el-col  :md="24" :lg="12">
          <select-spectrum v-model="telco.spectrumBand"  :disabled="stepSaved || canEdit" />
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :md="24">
          <sharer-rate-override
            v-model="telco.rate_id"
            :sharer-id="sharerId"
            :disabled="stepSaved || canEdit" />
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :md="24" :lg="12">
          <el-form-item label='Handover Date' required>
            <el-date-picker :format="format"
            v-model="telco.handover"  :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>

        <el-col :md="24" :lg="12">
          <el-form-item label='Commencement Date' required>
            <el-date-picker :format="format"
            v-model="telco.started"  :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>

        <el-col :md="24" :lg="12">
          <el-form-item label='On Air Date'>
            <el-date-picker :format="format"
            v-model="telco.onAir"  :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>

        <el-col :md="24" :lg="12">
          <el-form-item label='Expiry Date'>
            <el-date-picker :format="format"
            label='Contract End' v-model='expiryDate' disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="8">
        <el-col :span="12">
          <el-form-item prop="capex" label="CAPEX">
            <el-input type="number" placeholder="CAPEX"
            v-model="telco.capex"  :disabled="stepSaved || canEdit"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="OPEX">
            <el-input type="number" placeholder="OPEX" v-model="telco.opex"
            :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>
      </el-row>


      <el-row :gutter="8">
        <el-col :span="12">
          <el-form-item>
            Cabins &nbsp;<el-input-number v-model="telco.cabin" :min="0" :max="5" size="mini" :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <check-box v-model="telco.ownMeter"  :disabled="stepSaved || canEdit">{{'Own  ' + utilLabel + ' Meter'}}</check-box>
        </el-col>
      </el-row>

      <el-form-item label='Tenor (years)'>
        <el-slider
        v-model="tenor" :min="1" :max="20" show-stops show-input  :disabled="stepSaved || canEdit">
      </el-slider>
    </el-form-item>

    <el-row>
      <el-col align="middle">
        <el-button :plain="true" type="success" icon="fa fa-check" @click="onSave" :disabled="stepSaved || canEdit">Save</el-button>
        <el-button v-if="isSuper()" :plain="true" type="error" icon="fa fa-edit" @click="stepSaved=false"></el-button>
      </el-col>
    </el-row>
</section>
</el-form>

</template>


<script>

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

import SelectServiceType from '@/components/atoms/selects/SelectServiceType'
import SelectSpectrum from '@/components/atoms/selects/SelectSpectrum'
import SharerRateOverride from '@/components/finance/rates/SharerRateOverride'

export default {
  mixins: [DateMixins, PostMixins],

  components: {
    SelectServiceType,
    SelectSpectrum,
    SharerRateOverride
  },

  props: {
    siteId: {
      type: [String, Number],
      required: true
    },

    sharerName: {
      type: String,
      required: true
    },

    sharerId: {
      type: Number,
      required: true
    },

    editable: {
      type: Boolean,
      default: false
    },

    saved: {
      type: Boolean,
      default: false
    },

    sharerSiteId: {
      type: String,
      default: null
    },

    serviceType: {
      type: String,
      default: null
    },

    spectrumBand: {
      type: String,
      default: null
    },

    equipment: {
      type: Array,
      default: []
    }
  },

  methods: {
    // Pushes posts to the server when called.
    resetData () {
      this.telco = this.getTableStruct('licensee')
      this.telco.site_id = this.siteId
    },

    onSave () {
      this.telco.site_id = this.siteId
      this.telco.organisation_id = this.sharerId

      if (this.telco.started === 'invalid date') {
        this.telco.started = null
      }

      if (this.telco.expiry === 'invalid date') {
        this.telco.expiry = null
      }

      this.telco.outdoor = !this.telco.cabin

      this.telco.started = this.formatDateSql(this.telco.started)
      this.telco.expiry = this.formatDateSql(this.telco.expiry)

      this.telco.handover = this.formatDateSql(this.telco.handover)
      this.telco.onAir = this.formatDateSql(this.telco.onAir)

      if (this.telco && this.equipment && this.equipment.length > 0) {
        this.telco.equipment = this.equipment
      }

      this.saveForm(this, '/licensees', this.telco.id, this.telco, 'Sharer', this.success, this.failed)
    },

    success (response) {
      if (this.telco.cabin > 0) {
        let cabinAsset = {}
        cabinAsset.owner_id = this.telco.organisation_id
        cabinAsset.site_id = this.telco.site_id
        cabinAsset.category = 'Buildings'
        cabinAsset.type = 'Cabin'
        cabinAsset.qty = this.telco.cabin
        cabinAsset.isAuditable = true
        cabinAsset.usesPower = true
        cabinAsset.isExternal = true
        this.saveForm(this, '/assets', null, cabinAsset,  'Cabins', null, null, false)
      }


      if (this.telco.ownMeter) {
        let meterAsset = {}
        meterAsset.owner_id = this.telco.organisation_id
        meterAsset.site_id = this.telco.site_id
        meterAsset.category = 'Power'
        meterAsset.type = 'Own Meter'
        meterAsset.qty = 1
        meterAsset.isAuditable = false
        meterAsset.providesPower = true
        meterAsset.usesPower = false
        meterAsset.isExternal = true
        this.saveForm(this, '/assets', null, meterAsset, 'Own Meter', null, null, false)
      }

      this.stepSaved = true
    },

    failed (response) {
      console.error('Sharer Form save failed:', response)
      this.stepSaved = false
    }
  },

  computed: {
    expiryDate: function () {
      this.telco.expiry = this.contractExpiryDate(this.telco.started, this.tenor, 'years', 'YYYY-MM-DD')
      return this.telco.expiry
    }
  },

  data () {
    return {
      format: settings.selectDateFormat,
      tenor: 10,
      canEdit: this.editable,
      stepSaved: this.saved,
      utilLabel: this.getUtilLabel(),
      telco: this.getTableStruct('licensees')
    }

  }, // data


  created () {
    this.telco.telcoSiteId = this.sharerSiteId
    this.telco.spectrumBand = this.spectrumBand
    this.telco.serviceType = this.serviceType
  }
}

</script>
